import { useEffect, useState } from "react";
import tinycolor from "tinycolor2";
import { useSpacingValue } from "../../../../../../styles/index.js";
import { useColorPicker } from "../../../../hooks/useColorPicker.js";
import { useHue } from "./useHue.js";
import { useSaturation } from "./useSaturation.js";
function usePicker(props) {
  const spacingValue = useSpacingValue();
  const { swatchesPerRow, swatchesGap, swatchSize, value } = useColorPicker();
  const defaultWidth = computeRowWidth(Math.min(swatchesPerRow, 8), spacingValue * swatchesGap, swatchSize);
  const { saturationSize, hueSize } = props;
  const [selfColor, setSelfColor] = useState(() => tinycolor(value));
  const hue = useHue({
    defaultWidth,
    initialSize: hueSize,
    selfColor,
    setSelfColor
  });
  const saturation = useSaturation({
    defaultWidth,
    initialSize: saturationSize,
    selfColor,
    setSelfColor
  });
  useEffect(() => {
    setSelfColor((prevSelfColor) => {
      if (prevSelfColor.toHexString() === value) return prevSelfColor;
      return tinycolor(value);
    });
  }, [value]);
  return {
    hue,
    saturation
  };
}
function computeRowWidth(swatchPerRow, gridGapPx, chipSize) {
  return swatchPerRow * chipSize + (swatchPerRow - 1) * gridGapPx;
}
export {
  usePicker
};
//# sourceMappingURL=usePicker.js.map
